import { render } from "./RegulamentoMockado.vue?vue&type=template&id=35e88158&lang=true"
import script from "./RegulamentoMockado.vue?vue&type=script&lang=js"
export * from "./RegulamentoMockado.vue?vue&type=script&lang=js"
script.render = render

export default script